module.exports = __webpack_public_path__ + "static/media/axl.5f0c921d.png";